import React, { useEffect, useState } from 'react';
import { ControlLayout } from 'components/ControlLayout';
import { PortabilidadPaso1 } from 'components/portabilidad/PortabilidadPaso1';
import { PortabilidadPaso2 } from 'components/portabilidad/PortabilidadPaso2';
import { PortabilidadPaso6 } from 'components/portabilidad/PortabilidadPaso6';
import { PortabilidadPaso3 } from 'components/portabilidad/PortabilidadPaso3';
import { PortabilidadPaso4 } from 'components/portabilidad/PortabilidadPaso4';
import { PortabilidadPaso5 } from 'components/portabilidad/PortabilidadPaso5';
import { StageBar } from 'components/StageBar';
import { ActionButtonConfig } from 'models/ActionButtonConfig';
import checkIsMobile from 'utils/CheckIsMobile';
import { LoadingModal } from 'components/response/LoadingModal';
import 'assets/scss/portabilidad-container.scss';
import { DialogInfoPortabilidad } from 'components/portabilidad/DialogInfoPortablidad';
import { PORTABILITY_FORM_DATA_KEY_STORAGE } from 'constants/FormConstants';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { MultiFormPortabilityCommandImps } from 'services/portability/MultiFormPortabilityCommandImpl';
import { FormContext } from 'context/FormContext';

export const PortabilidadContainer = () => {
	const [stage, setStage] = useState(0);
	const [enableButton, setEnableButton] = useState(true);
	const [showLoadingModal, setShowLoadingModal] = useState(false);
	const [formData, setformData] = useState({});
	const portabilityCommand = new MultiFormPortabilityCommandImps(setStage, setShowLoadingModal);
	const storageService = new StorageServiceImpl();

	const isFirstView = storageService.getData(PORTABILITY_FORM_DATA_KEY_STORAGE, sessionStorage);

	const configAction: ActionButtonConfig[] = [
		{
			stage: 0,
			buttonBackName: 'Volver',
			buttonNextName: 'Comenzar',

			buttonBackClick: () => {
				portabilityCommand.backToPortabilityHomePage();
			},
			buttonNextClick: () => {
				portabilityCommand.saveForm(stage, { ...formData, flow: 'PORTABILIDAD', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		},
		{
			stage: 1,
			buttonBackName: 'Volver',
			buttonNextName: 'Continuar',

			buttonBackClick: () => {
				portabilityCommand.resetIdAndStatus();
				portabilityCommand.backOneStep(stage);
			},
			buttonNextClick: () => {
				portabilityCommand.saveForm(stage, { ...formData, flow: 'PORTABILIDAD', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		},
		{
			stage: 2,
			buttonBackName: 'Volver',
			buttonNextName: 'Continuar',

			buttonBackClick: () => {
				portabilityCommand.resetIdAndStatus();
				portabilityCommand.backOneStep(stage);
			},
			buttonNextClick: () => {
				portabilityCommand.saveForm(stage, { ...formData, flow: 'PORTABILIDAD', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		},
		{
			stage: 3,
			buttonBackName: 'Volver',
			buttonNextName: 'Continuar',

			buttonBackClick: () => {
				portabilityCommand.backOneStep(stage);
			},
			buttonNextClick: () => {
				portabilityCommand.saveForm(stage, { ...formData, flow: 'PORTABILIDAD', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		},
		{
			stage: 4,
			buttonBackName: 'Volver',
			buttonNextName: 'Continuar',

			buttonBackClick: () => {
				portabilityCommand.backOneStep(stage);
			},
			buttonNextClick: () => {
				portabilityCommand.saveForm(stage, { ...formData, flow: 'PORTABILIDAD', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		},
		{
			stage: 5,
			buttonBackName: 'Volver',
			buttonNextName: 'Solicitar oferta',

			buttonBackClick: () => {
				portabilityCommand.backOneStep(stage);
			},
			buttonNextClick: () => {
				portabilityCommand.saveForm(stage, { ...formData, flow: 'PORTABILIDAD', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		},
	];
	const classContainer = checkIsMobile()
		? 'portabilidad-container'
		: 'portabilidad-container card-box';

	useEffect(
		() => {
			portabilityCommand.login();
		},
		//eslint-disable-next-line
		[]
	);
	return (
		<div className={classContainer}>
			<FormContext.Provider
				value={{
					setError: setEnableButton,
					setData: setformData,
					storage: storageService,
				}}
			>
				{isFirstView === null ? <DialogInfoPortabilidad onClose={() => null} /> : null}

				<LoadingModal showLoadingModal={showLoadingModal} />
				<StageBar value={stage + 1} maxValue={configAction.length} />
				{
					{
						0: <PortabilidadPaso1 />,
						1: <PortabilidadPaso2 />,
						2: <PortabilidadPaso3 />,
						3: <PortabilidadPaso4 />,
						4: <PortabilidadPaso5 />,
						5: <PortabilidadPaso6 />,
					}[stage]
				}
				<ControlLayout
					inputError={enableButton}
					handleBackClick={configAction[stage].buttonBackClick}
					handleNextClick={configAction[stage].buttonNextClick}
					buttonBackName={configAction[stage].buttonBackName}
					buttonNextName={configAction[stage].buttonNextName}
				/>
			</FormContext.Provider>
		</div>
	);
};
